let route = {
    path: '/modules/fund',
    name: 'fund',
    component: () => import('@/modules/fund/index.vue'),
    children: [
        {
            path: 'manage',
            name: 'Fund-Manage',
            component: () => import('@/modules/fund/manage/index.vue'),
            meta: {
                pageTitle: '客户资金管理',
            }
        },
        {
            path: 'bank',
            name: 'Fund-BANK',
            component: () => import('@/modules/fund/bank/index.vue'),
            meta: {
                pageTitle: '银行管理',
            }
        }
    ],
    
};
export const FundRuter = route;
